// How a feed's new entries are shown in the notification centre.

import type { NotificationPresenter } from "@/notifications/client";
import { FEED_NOTIFICATIONS, type FeedKind } from "@/feeds/model/wire.js";
import { qk } from "@/platform/client";
import { FeedKindIcon } from "@/feeds/ui/components/FeedKindIcon.js";

export const feedNotifications: NotificationPresenter = {
  source: FEED_NOTIFICATIONS,
  icon: (n, size) => (
    <FeedKindIcon kind={(n.meta?.feedKind as FeedKind) ?? "generic"} size={size} />
  ),
  // A notification is sent for each entry a fetch finds.
  refreshes: [qk.feeds.all, qk.feedCategories.all, qk.feedEntries.all],
};
